<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    max-width="1000px"
    persistent>
    <v-card>
      <v-card-text class="px-0 pb-0">
        <v-toolbar class="elevation-2" color="error">
          <v-toolbar-title class="ml-0">
            <span class="font-weight-bold white--text">{{
              $t('entities.invoices.restoreTransaction')
            }}</span>
          </v-toolbar-title>
          <v-spacer />
          <v-btn @click="close" icon dark>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container>
          <v-card class="pb-2">
            <v-simple-table class="do-not-apply-hover" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>
                      {{ $t('entities.invoices.attributes.id') }}
                    </td>
                    <td colspan="2" class="font-weight-bold">
                      {{ transaction?.id || '—' }}
                    </td>
                    <td>
                      {{ $t('entities.invoices.attributes.coins') }}
                    </td>
                    <td colspan="3" class="font-weight-bold">
                      {{ formatCoins }}
                    </td>
                  </tr>
                  <tr>
                    <td>{{ $t('entities.invoices.attributes.byUser') }}</td>
                    <td colspan="2" class="font-weight-bold">
                      {{ sellerUserName || '—' }}
                    </td>
                    <td>{{ $t('miscellaneous.arena') }}</td>
                    <td colspan="3" class="font-weight-bold">
                      {{ arenaName || '—' }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row class="mt-4">
              <v-col cols="12">
                <v-form ref="form" @submit.prevent="onRestore" method="POST">
                  <v-row align="center">
                    <v-col cols="12" class="position-relative px-6">
                      <v-textarea
                        v-model="restoringReason"
                        :rules="required"
                        :label="`${$t(
                          'entities.invoices.attributes.restoringReason',
                        )} *`"
                        prepend-icon="mdi-text"
                        rows="1"
                        auto-grow
                        persistent-hint />
                    </v-col>
                  </v-row>
                  <ValidationErrors
                    v-if="validationErrors.length"
                    :errors="validationErrors" />
                </v-form>
              </v-col>
            </v-row>
          </v-card>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close" color="dark darken-1" text>
          {{ $t('miscellaneous.cancel') }}
        </v-btn>
        <v-spacer />
        <v-btn
          :disabled="restoring"
          :loading="restoring"
          color="error"
          text
          @click="onRestore">
          <span>{{
            restoring
              ? $t('entities.invoices.restoringTransaction')
              : $t('entities.invoices.restoreTransaction')
          }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationErrors from '@/components/crud/ValidationErrors.vue'

export default {
  name: 'TransactionRestoreDialog',
  components: { ValidationErrors },
  props: {
    value: { type: Boolean, default: false },
    transaction: { type: Object, default: null },
    arenaName: { type: String, default: '' },
    sellerUserName: { type: String, default: '' },
    restoring: { type: Boolean, default: false },
  },
  data() {
    return {
      restoringReason: '',
      validationErrors: [],
    }
  },
  computed: {
    required() {
      return [(v) => !!v || this.$t('validation.required')]
    },
    formatCoins() {
      if (this.transaction?.coins_given === undefined) return '—'
      return `${this.transaction.coins_given}`
    },
  },
  watch: {
    value(open) {
      if (open) {
        this.restoringReason = ''
        this.validationErrors = []
      }
      if (!open && this.$refs.form) {
        this.$refs.form.resetValidation()
      }
    },
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    async onRestore() {
      this.validationErrors = []
      const form = this.$refs.form
      if (!form) return
      const valid = await form.validate()
      if (!valid) return
      this.$emit('restore', { restoring_reason: this.restoringReason })
    },
  },
}
</script>

<style scoped>
.position-relative {
  position: relative;
}

.required-fields {
  position: absolute;
  right: 13px;
  top: 15px;
  color: red;
}
</style>
